<template>
  <div class="archives">
    <!-- 推荐结果 -->
    <!-- 地址栏有name为推荐结果页面,无name为档案详情页面 -->
    <!-- 第一个白框里的内容 -->
    <div class="outer-border margin-bottom-three">
      <el-row class="title-border-bottom">
        <div class="b-title fl">推荐结果</div>
        <el-button type="warning" class="small-btn fr" icon="el-icon-share" @click="shareF()">分享</el-button>
      </el-row>
      <el-col style="padding-right:20px">
        <share :config="config1" style="display:inline-block" v-if="isShare" class="fr"></share>
      </el-col>

      <div class="content-two">
        <el-form :model="form" status-icon ref="form" label-width="80px">
          <el-form-item label="基本信息:">
            <table class="table">
              <tr>
                <td class="table-title">姓名</td>
                <td>{{ form.da.name }}</td>
                <td class="table-title">性别</td>
                <td>{{ form.da.sex }}</td>
                <td class="table-title">年龄</td>
                <td>{{ form.da.age }}</td>
<!--                <td class="table-title" v-if="form.da.sex == '女'">生育史</td>-->
<!--                <td v-if="form.da.sex == '女'">-->
<!--                  {{-->
<!--                    form.ya.childbearingHistory-->
<!--                      ? form.ya.childbearingHistory-->
<!--                      : ""-->
<!--                  }}-->
<!--                </td>-->
<!--                <td v-if="form.da.sex == '女'" class="table-title red-long-btn">孕妇</td>-->
<!--                <td v-if="form.da.sex == '女'" class="red-color-font">{{ isYF(form.ya.isPregnant) }}</td>-->
              </tr>
              <tr>
                <td class="table-title">药物过敏史</td>
                <td
                  colspan="10"
                  v-if="form.da.sex == '女'"
                >{{ jwyws(form.ya.medicineIrritabilityHistory, "medicine") }}</td>
                <td colspan="2" v-else>{{ jwyws(form.ya.medicineIrritabilityHistory, "medicine") }}</td>
              </tr>
            </table>
          </el-form-item>
          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="8">
              <el-form-item label="初诊时间:">
                <el-date-picker
                  disabled
                  size="small"
                  v-model="form.da.firstTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="初诊时间"
                  style="width:auto"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="诊时:">
                <el-input size="small" v-model="form.da.unmber1" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="本诊时间:">
                <el-date-picker
                  disabled
                  size="small"
                  v-model="form.da.visitTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="本诊时间"
                  style="width:auto"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" class="row-bg" justify="space-between">

          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="主要病症:">
                {{form.da.disease}}
              </el-form-item>
            </el-col>
          </el-row>


          <el-row v-if="wuxing.length > 0">
            <el-col>
              <el-form-item :span="24" label="诊断分析:"></el-form-item>
              <p class="remarks">系统在中医古籍知识为基础上，结合您选择的症状，推理出可能的病机。</p>
              <div class="wuxi">
                <div class="wuxing" v-for="item in wuxing" :key="item.id">
                  <div class="wuxing_name" :span="6">{{item.attribute}}</div>
                  <div class="wuxing_num" :span="18">{{item.types}}</div>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- 古代方剂 -->
<!--          <el-row v-if="gdfj.length > 0">-->
<!--            <el-col :span="24">-->
<!--              <el-form-item class="margin-left-zero">-->
<!--                <table class="table">-->
<!--                  <tr>-->
<!--                    <td :rowspan="Math.ceil(gdfj.length / 2) + 1" class="table-a">古代方剂</td>-->
<!--                    <td colspan="6">{{ form.da.gfName }}</td>-->
<!--                  </tr>-->
<!--                  <tr v-for="(itemG, indexG) in gdfj" :key="itemG.id" v-show="indexG % 2 == 0">-->
<!--                    <td>-->
<!--                      {{ gdfj[indexG].medicineName }}-->
<!--                      <img-->
<!--                        :src="require('@/assets/list/jin.png')"-->
<!--                        alt-->
<!--                        class="vertical-middle"-->
<!--                        v-if="gdfj[indexG].anMedicineType == '0'"-->
<!--                      />-->
<!--                      <img-->
<!--                        :src="require('@/assets/list/fan.png')"-->
<!--                        alt-->
<!--                        class="vertical-middle"-->
<!--                        v-if="gdfj[indexG].xfxwMedicineType == '1'"-->
<!--                      />-->
<!--                      <img-->
<!--                        :src="require('@/assets/list/wei2.png')"-->
<!--                        alt-->
<!--                        class="vertical-middle"-->
<!--                        v-if="gdfj[indexG].xfxwMedicineType == '2'"-->
<!--                      />-->
<!--                    </td>-->
<!--                    <td>{{ gdfj[indexG].dosage }}{{ gdfj[indexG].unit }}</td>-->
<!--                    <td style="width: 20%">{{gdfj[indexG].zf}}</td>-->
<!--                    <td v-if="indexG < gdfj.length - 1">-->
<!--                      {{ gdfj[indexG + 1].medicineName }}-->
<!--                      <img-->
<!--                        :src="require('@/assets/list/jin.png')"-->
<!--                        alt-->
<!--                        class="vertical-middle"-->
<!--                        v-if="gdfj[indexG + 1].anMedicineType == '0'"-->
<!--                      />-->
<!--                      <img-->
<!--                        :src="require('@/assets/list/fan.png')"-->
<!--                        alt-->
<!--                        class="vertical-middle"-->
<!--                        v-if="gdfj[indexG + 1].xfxwMedicineType == '1'"-->
<!--                      />-->
<!--                      <img-->
<!--                        :src="require('@/assets/list/wei2.png')"-->
<!--                        alt-->
<!--                        class="vertical-middle"-->
<!--                        v-if="gdfj[indexG + 1].xfxwMedicineType == '2'"-->
<!--                      />-->
<!--                    </td>-->
<!--                    <td-->
<!--                      v-if="indexG < gdfj.length - 1"-->
<!--                    >{{ gdfj[indexG + 1].dosage }}{{ gdfj[indexG + 1].unit }}</td>-->
<!--                    <td style="width: 20%" v-if="indexG < gdfj.length - 1">{{gdfj[indexG + 1].zf}}</td>-->
<!--                    &lt;!&ndash; <td v-if="indexG < gdfj.length - 2">-->
<!--                      {{ gdfj[indexG + 2].medicineName }}-->
<!--                      <img-->
<!--                        :src="require('@/assets/list/jin.png')"-->
<!--                        alt-->
<!--                        class="vertical-middle"-->
<!--                        v-if="gdfj[indexG + 2].anMedicineType == '0'"-->
<!--                      />-->
<!--                      <img-->
<!--                        :src="require('@/assets/list/fan.png')"-->
<!--                        alt-->
<!--                        class="vertical-middle"-->
<!--                        v-if="gdfj[indexG + 2].xfxwMedicineType == '1'"-->
<!--                      />-->
<!--                      <img-->
<!--                        :src="require('@/assets/list/wei2.png')"-->
<!--                        alt-->
<!--                        class="vertical-middle"-->
<!--                        v-if="gdfj[indexG + 2].xfxwMedicineType == '2'"-->
<!--                      />-->
<!--                    </td>-->
<!--                    <td-->
<!--                      v-if="indexG < gdfj.length - 2"-->
<!--                    >{{ gdfj[indexG + 2].dosage }}{{ gdfj[indexG + 2].unit }}</td> &ndash;&gt;-->
<!--                  </tr>-->
<!--                </table>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--          </el-row>-->
          <!-- 当代方剂 -->
<!--          <el-row v-if="ddfj.length > 0">-->
<!--            <el-col :span="24">-->
<!--              <el-form-item class="margin-left-zero">-->
<!--                <table class="table">-->
<!--                  <tr>-->
<!--                    <td :rowspan="Math.ceil(ddfj.length / 2) + 1" class="table-a">当代方剂</td>-->
<!--                    <td colspan="8">-->
<!--                      <span style="margin-left:14%">{{ form.da.gfName }}</span>-->
<!--                      <span class="fr">-->
<!--                        <el-button-->
<!--                          type="primary"-->
<!--                          class="btn-medium"-->
<!--                          style="margin-left:10px"-->
<!--                          @click="onChangeEvaluate"-->
<!--                          v-if="!evaluateInfo.id"-->
<!--                        >评价</el-button>-->
<!--                        <el-button-->
<!--                          type="warning"-->
<!--                          class="btn-medium"-->
<!--                          style="background-color: #f64420;"-->
<!--                          v-if="ddfj.length > 0 && !isYS"-->
<!--                          @click="addCar(form.da.cfId, 1)"-->
<!--                        >购药</el-button>-->
<!--                        <el-button-->
<!--                          type="warning"-->
<!--                          class="btn-medium"-->
<!--                          @click="editFangJi()"-->
<!--                        >修改方剂</el-button>-->
<!--                      </span>-->
<!--                    </td>-->
<!--                  </tr>-->
<!--                  <tr v-for="(itemD, indexD) in ddfj" :key="indexD.id" v-show="indexD % 2 == 0">-->
<!--                    <td>-->
<!--                      {{ ddfj[indexD].medicineName }}-->
<!--                      <img-->
<!--                        :src="require('@/assets/list/ti.png')"-->
<!--                        alt-->
<!--                        class="vertical-middle"-->
<!--                        v-if="ddfj[indexD].rpMedicineType == '0'"-->
<!--                      />-->
<!--                      <img-->
<!--                        :src="require('@/assets/list/fan.png')"-->
<!--                        alt-->
<!--                        class="vertical-middle"-->
<!--                        v-if="ddfj[indexD].xfxwMedicineType == '1'"-->
<!--                      />-->
<!--                      <img-->
<!--                        :src="require('@/assets/list/wei2.png')"-->
<!--                        alt-->
<!--                        class="vertical-middle"-->
<!--                        v-if="ddfj[indexD].xfxwMedicineType == '2'"-->
<!--                      />-->
<!--                    </td>-->
<!--                    <td>{{ ddfj[indexD].dosage }}{{ ddfj[indexD].unit }}</td>-->
<!--                    <td style="width: 20%">{{ ddfj[indexD].zyzf }}</td>-->

<!--                    <td v-if="indexD < ddfj.length - 1">-->
<!--                      {{ ddfj[indexD + 1].medicineName }}-->
<!--                      <img-->
<!--                        :src="require('@/assets/list/ti.png')"-->
<!--                        alt-->
<!--                        class="vertical-middle"-->
<!--                        v-if="ddfj[indexD + 1].rpMedicineType == '0'"-->
<!--                      />-->
<!--                      <img-->
<!--                        :src="require('@/assets/list/fan.png')"-->
<!--                        alt-->
<!--                        class="vertical-middle"-->
<!--                        v-if="ddfj[indexD + 1].xfxwMedicineType == '1'"-->
<!--                      />-->
<!--                      <img-->
<!--                        :src="require('@/assets/list/wei2.png')"-->
<!--                        alt-->
<!--                        class="vertical-middle"-->
<!--                        v-if="ddfj[indexD + 1].xfxwMedicineType == '2'"-->
<!--                      />-->
<!--                    </td>-->
<!--                    <td v-if="indexD < ddfj.length - 1">-->
<!--                      {{ ddfj[indexD + 1].dosage }}{{ ddfj[indexD + 1].unit }}-->
<!--                    </td>-->
<!--                    <td style="width: 20%" v-if="indexD < ddfj.length - 1">-->
<!--                      {{ddfj[indexD + 1].zyzf}}-->
<!--                    </td>-->
<!--                    &lt;!&ndash; <td v-if="indexD < ddfj.length - 2">-->
<!--                      {{ ddfj[indexD + 2].medicineName }}-->
<!--                      <img-->
<!--                        :src="require('@/assets/list/ti.png')"-->
<!--                        alt-->
<!--                        class="vertical-middle"-->
<!--                        v-if="ddfj[indexD + 2].rpMedicineType == '0'"-->
<!--                      />-->
<!--                      <img-->
<!--                        :src="require('@/assets/list/fan.png')"-->
<!--                        alt-->
<!--                        class="vertical-middle"-->
<!--                        v-if="ddfj[indexD + 2].xfxwMedicineType == '1'"-->
<!--                      />-->
<!--                      <img-->
<!--                        :src="require('@/assets/list/wei2.png')"-->
<!--                        alt-->
<!--                        class="vertical-middle"-->
<!--                        v-if="ddfj[indexD + 2].xfxwMedicineType == '2'"-->
<!--                      />-->
<!--                    </td>-->
<!--                    <td-->
<!--                      v-if="indexD < ddfj.length - 2"-->
<!--                    >{{ ddfj[indexD + 2].dosage }}{{ ddfj[indexD + 2].unit }}</td> &ndash;&gt;-->
<!--                  </tr>-->
<!--                </table>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
            <el-row v-if="xwList&&xwList.length">
              <el-col :span="24">
                 <div style="font-size: 16px;margin: 0 0 20px 10px">推荐穴位</div>
                 <div v-for="(item2,index2) in xwList" :key="index2" class="box2">
                   <div class="box-content">
                     <div class="hanzi" v-for="(j,i) in item2.kong" :key="i">
                       <div class="pinying">{{ j.pingyin }}</div>
                       <div class="tianzige"></div>
                       <div class="tianzige2"></div>
                       <div class="zt">{{j.name}}</div>
                     </div>
                   </div>
                   <div class="viewInfo" v-show="item2.acupointId" @click="goAcupointDetails(item2)">查看详情</div>
                 </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                 <div style="font-size: 16px;margin: 0 0 20px 10px">推荐建议古方</div>
                 <div v-for="(item,index) in obj.newArr" :key="index" class="box">
                   <div class="box-content">
                     <div class="hanzi" v-for="(j,i) in item.kong" :key="i">
                       <div class="pinying">{{ j.pingyin }}</div>
                       <div class="tianzige"></div>
                       <div class="tianzige2"></div>
                       <div class="zt">{{j.name}}</div>
                     </div>
                   </div>
                   <div class="viewInfo" @click="goAncientDetails(item)">查看详情</div>
                 </div>
              </el-col>
            </el-row>
          <!-- 医师修正方剂 -->
<!--          <el-row v-if="ysxzfj.length > 0">-->
<!--            <el-col :span="24">-->
<!--              <el-form-item class="margin-left-zero">-->
<!--                <table class="table">-->
<!--                  <tr>-->
<!--                    <td :rowspan="Math.ceil(ysxzfj.length / 2) + 1" class="table-a">修正方剂</td>-->
<!--                    <td colspan="6">-->
<!--                      <span style="margin-left:14%">-->
<!--                        {{ form.da.gfName }} +-->
<!--                        <span-->
<!--                          v-if="form.da.physician"-->
<!--                        >{{ form.da.physician.name }} +</span>-->
<!--                        {{ getTime(ysxzfj[0].createDate) }}-->
<!--                      </span>-->
<!--                      <span class="fr">-->
<!--                        &lt;!&ndash; <el-button-->
<!--                          type="primary"-->
<!--                          class="btn-medium"-->
<!--                          style="margin-left:10px"-->
<!--                          @click="onChangeEvaluate"-->
<!--                          v-if="!evaluateInfo.id"-->
<!--                        >评价</el-button> &ndash;&gt;-->
<!--                        <el-button-->
<!--                          type="warning"-->
<!--                          class="btn-medium"-->
<!--                          v-if="ysxzfj.length > 0 && !isYS"-->
<!--                          style="margin-left:10px;background-color: #f64420;"-->
<!--                          @click="addCar(form.da.id, 2)"-->
<!--                        >购药</el-button>-->
<!--                        <el-button-->
<!--                          type="warning"-->
<!--                          class="btn-medium"-->
<!--                          @click="editFangJi()"-->
<!--                          v-if="ysxzfj.length > 0"-->
<!--                        >修改方剂</el-button>-->
<!--                      </span>-->
<!--                    </td>-->
<!--                  </tr>-->
<!--                  <tr v-for="(itemY, indexY) in ysxzfj" :key="indexY.id" v-show="indexY % 2 == 0">-->
<!--                    <td>{{ ysxzfj[indexY].medicineName }}</td>-->
<!--                    <td>{{ ysxzfj[indexY].dosage }}{{ ysxzfj[indexY].unit }}</td>-->
<!--                    <td style="width: 20%">{{ysxzfj[indexY].method}}</td>-->
<!--                    <td v-if="indexY < ysxzfj.length - 1">{{ ysxzfj[indexY + 1].medicineName }}</td>-->
<!--                    <td v-if="indexY < ysxzfj.length - 1">-->
<!--                      {{ ysxzfj[indexY + 1].dosage}}{{ ysxzfj[indexY + 1].unit }}-->
<!--                    </td>-->
<!--                    <td style="width: 20%" v-if="indexY < ysxzfj.length - 1">{{ysxzfj[indexY+1].method}}</td>-->
<!--                    &lt;!&ndash; <td v-if="indexY < ysxzfj.length - 2">{{ ysxzfj[indexY + 2].medicineName }}</td>-->
<!--                    <td v-if="indexY < ysxzfj.length - 2">-->
<!--                      {{ ysxzfj[indexY + 2].dosage-->
<!--                      }}{{ ysxzfj[indexY + 2].unit }}-->
<!--                    </td> &ndash;&gt;-->
<!--                  </tr>-->
<!--                </table>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--          </el-row>-->
<!--          <p class="test" v-if="jinyao">-->
<!--            &lt;!&ndash; <p class="test"> &ndash;&gt;-->
<!--            <span>禁</span>：禁止使用药物。-->
<!--          </p>-->
<!--          <p class="test1" v-if="jinyao">-->
<!--            &lt;!&ndash; <p class="test1" > &ndash;&gt;-->
<!--            <span>替</span>：国家法律规定古方中的中药已禁用，根据中医知识替换成为此药，替换的药物与原药物的功效基本相同。-->
<!--          </p>-->
<!--          <p class="test2" v-if="fanyao">-->
<!--            &lt;!&ndash; <p class="test2" > &ndash;&gt;-->
<!--            <span>反</span>：指配伍禁忌，指某些中药合用会产生或增强剧烈的毒副作用或降低、破坏药效，因而应该避免配合应用。-->
<!--          </p>-->
<!--          <p class="test3" v-if="weiyao">-->
<!--            &lt;!&ndash; <p class="test3" > &ndash;&gt;-->
<!--            <span>畏</span>：同反药配伍禁忌，指不要让有些药物合用，合用后的后果会产生各种副作用。-->
<!--          </p>-->

<!--          <p class="smallRedSize" v-if="form.da.sex == '女' && !isYS">如您是孕妇或您一年内有备孕意向，请线下就医购药！</p>-->
<!--          <el-row>-->
<!--            <el-col :span="24">-->
<!--              <el-form-item class="margin-left-zero border-ten"></el-form-item>-->
<!--            </el-col>-->
<!--          </el-row>-->
        </el-form>
      </div>
    </div>
    <!-- 医师修正方剂弹框 -->
    <el-dialog
      :title="form.da.gfName"
      :visible.sync="dialogTableVisible"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div class="margin-left-zero margin20" v-if="ysxzfj.length > 0">
        <table class="table">
          <tr>
            <!-- 当代方剂-->
            <td>草药名称</td>
            <td style="width: 29%">剂量</td>
            <td>单位</td>
            <td>制法</td>
          </tr>
          <tr v-for="(itemYX, indexYX) in xgysxzfj" :key="itemYX.id">
            <td>
              <el-select v-model="itemYX.medicineName" remote :remote-method="remoteMethod" @change= 'handleChange' class="set-small-width" filterable placeholder="请输入草药名称" no-data-text='该药品不存在，请输入其他药品查询' clearable>
                <el-option
                  v-for="(item,index) in medicinelist"
                  :key="index"
                  :label="item.value"
                  :value="item.id">
                </el-option>
              </el-select>
              <!-- <el-autocomplete
                class="set-small-width"
                v-model="itemYX.medicineName"
                :fetch-suggestions="querySearchAsync"
                @select="handleSelect(itemYX)"
                placeholder="请输入草药名称"
              ></el-autocomplete> -->
            </td>
            <td>
              <el-input v-model="itemYX.dosage" onkeyup="value=value.replace(/[^\d^\.]+/g,'')" placeholder="请输入剂量，格式为数字"></el-input>
            </td>
            <td>
              <el-select v-model="itemYX.unit" class="set-small-width">
                <el-option v-for="(item,index) in unitMeasure"
                           :key="index"
                           :label="item.lableTwo"
                           :value="item.lableTwo"></el-option>
              </el-select>
            </td>
            <td>
              <el-input v-model="itemYX.method"  class="set-small-width leftSty" autosize type="textarea" placeholder="请输入制法"></el-input>
            </td>
            <td>
              <img
                :src="require('@/assets/img/reduce.png')"
                alt
                class="vertical-middle"
                @click="reduceRow(indexYX)"
              />
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <img
                :src="require('@/assets/img/addRed.png')"
                alt
                class="vertical-middle"
                @click="addRow()"
              />
            </td>
          </tr>
        </table>
      </div>
      <div class="margin-left-zero margin20" v-else>
        <table class="table">
          <tr>
            <!-- 修改方剂 -->
            <td>草药名称</td>
            <td style="width: 29%">剂量</td>
            <td>单位</td>
            <td>制法</td>
          </tr>
          <tr v-for="(itemDX, indexDX) in xgysxzfj" :key="itemDX.id">
            <td>
              <el-select v-model="itemDX.medicineName" remote :remote-method="remoteMethod" @change= 'handleChange' class="set-small-width" filterable placeholder="请输入草药名称" no-data-text='该药品不存在，请输入其他药品查询' clearable>
                <el-option
                  v-for="(item,index) in medicinelist"
                  :key="index"
                  :label="item.value"
                  :value="item.id">
                </el-option>
              </el-select>
              <!-- <el-autocomplete
                ref="autocomplete"
                class="set-small-width"
                v-model="itemDX.medicineName"
                :fetch-suggestions="querySearchAsync"
                @select="handleSelect(itemDX)"
                placeholder="请输入草药名称"
              ></el-autocomplete> -->
            </td>
            <td>
              <el-input v-model="itemDX.dosage" onkeyup="value=value.replace(/[^\d^\.]+/g,'')" class="set-small-width leftSty" :controls= "false" placeholder="请输入剂量，格式为数字"></el-input>
            </td>
            <td>
              <el-select v-model="itemDX.unit" class="set-small-width">
                <el-option v-for="(item,index) in unitMeasure"
                           :key="index"
                           :label="item.lableTwo"
                           :value="item.lableTwo"></el-option>
              </el-select>
            </td>
            <td>
              <el-input v-model="itemDX.method" autosize  class="set-small-width leftSty" type="textarea" placeholder="请输入制法"></el-input>
            </td>
            <td>
              <img
                :src="require('@/assets/img/reduce.png')"
                alt
                class="vertical-middle"
                @click="reduceRow(indexDX)"
              />
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <img
                :src="require('@/assets/img/addRed.png')"
                alt
                class="vertical-middle"
                @click="addRow()"
              />
            </td>
          </tr>
        </table>
      </div>
      <el-row class="text-center">
        <el-col :span="24">
          <el-button type="danger" @click="submitEdit()">确定</el-button>
          <el-button type="info" @click="cancle()">取消</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      title="权限访问"
      :visible.sync="dialogTableVisibleQX"
      :close-on-click-modal="false"
      class="dialogQX"
      center
      :show-close="false"
    >
      <p class="contentQX text-center">
        是否向
        <span class="orangeQX">{{ form.da.name }}</span>
        申请查看{{ form.da.disease }}的其他诊时权限
      </p>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="submitQX()" class="smallBtn red">确定</el-button>
        <el-button type="primary" @click="cancleQX()" class="smallBtn blue">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "archives",
  components: {},
  data() {
    return {
      // noDisplay: false, //咨询医师是否显示
      form: {
        ya: {}, // 医案详情
        da: {} //档案详情
      },
      wuxing: [], // 五行诊断
      ancientList: {},
      gdfj: [], //古代方剂
      ddfj: [], //当代方剂
      maxDoseList: [], //购药暂存当代方剂最大剂量判断
      ysxzfj: [], //医师修正方剂
      xgysxzfj: [], //修改医师修正方剂
      jzjl: [], //显示最新的就诊记录
      oddjzjl: [], //之前的就诊记录
      alljzjl: [], //全部就诊记录
      content: "", //咨询医师内容
      dialogTableVisible: false, //修改方剂弹框
      medicinelist: [], // 药名称
      medicinelist_all: [], // 草药集合
      rangeNumber: 10, // 下拉框展示默认10条
      dialogTableVisibleQX: false, //权限访问弹框
      isYS: false,
      zhenshiId: "",
      show: false, //查看更多是否显示
      jinyao: false,
      fanyao: false,
      weiyao: false,
      evaluateFromVisible: false, // 评价输入框,
      levelList: [],
      levelValue: "", //评价等级
      evaluateText: "", //评价框绑定
      evaluateInfo: {}, // 评价详情
      levelText: "", //评价文字展示
      restaurants: [],
      unitMeasure: [],
      obj: [],
      xwList:[]
    };
  },
  methods: {
    moreDate() {
      this.jzjl = this.jzjl.concat(this.oddjzjl);
      this.show = false;
    },
    selectZhenShi(val) {
      this.getDetailDangAn(val);
    },
    cancleQX() {
      let that = this;
      that.dialogTableVisibleQX = false;
      that.form.da.id = that.zhenshiId;
    },
    async unitMeasu() {
      let url = "/sysDict/findByType";
      let params = {
        type: "cdoseunit"
      }
      this.$http.post(url,params).then(res => {
        this.unitMeasure = res.data.data
      })
    },
    //获取档案详情
    async getDetailDangAn(id) {
      let that = this;
      let params = {
        id: id,
        loginIdentity: JSON.parse(sessionStorage.getItem("YS")),
        userId: that.userInfo.id
      };
      let url = "medicalCasesPc/getArchivesMoreById";
      await that.$http
        .post(url, params)
        .then(response => {
          let res = response.data;
          if (res.code == 200) {
            let objData = {
              newArr: []
            }
            objData.medId = res.data.medId
            res.data.gfList.forEach(item => {
              // objData.id = item.id
              let kong = []
              let pingyin = Array.from(item.gfNamepy.trim().split(" "))
              let pyName = Array.from(item.rectificationName)
              pyName.filter((item, j) => {
                kong.push(
                    {
                      pingyin: pingyin[j],
                      name: item
                    }
                  )
              })
              objData.newArr.push({
                kong: kong,
                id: item.id
              })
            })
            that.obj = objData
            that.ancientList = res.data
            that.form.da = res.data;
            that.zhenshiId = res.data.id;
            //诊断分析
            if (that.form.da.archivesDiagnoanaly) {
              that.wuxing = that.form.da.archivesDiagnoanaly;
            }
            if (that.form.da.unmber) {
              that.form.da.unmber1 =
                that.toChinesNum(that.form.da.unmber) + "诊时";
            }
            // 古代方剂
            if (that.form.da.ancientPrescriptionSlaves) {
              that.gdfj = that.form.da.ancientPrescriptionSlaves;
              for (let index = 0; index < that.gdfj.length; index++) {
                if (that.gdfj[index].anMedicineType == 0) {
                  that.jinyao = true;
                }
                if (that.gdfj[index].xfxwMedicineType == 1) {
                  that.fanyao = true;
                } else if (that.gdfj[index].xfxwMedicineType == 2) {
                  that.weiyao = true;
                }
              }
            }
            //当代方剂
            if (that.form.da.zzPrescriptionSlaves) {
              that.ddfj = that.form.da.zzPrescriptionSlaves;
            }
            //当代方剂maxDoseList提交判断
            // if (that.form.da.maxDoseList) {
            that.maxDoseList = that.form.da.maxDoseList;
            // }
            //医师修正方剂
            if (that.form.da.physicianChangePrescriptionList) {
              that.ysxzfj = that.form.da.physicianChangePrescriptionList;
            }
            //就诊记录
            if (that.form.da.physicianCommunicationList) {
              that.alljzjl = that.form.da.physicianCommunicationList;
              if (that.alljzjl.length > 4) {
                that.show = true;
                that.jzjl = [];
                that.oddjzjl = [];
                for (let i = 0; i < that.alljzjl.length; i++) {
                  if (i < 4) {
                    that.jzjl.push(that.alljzjl[i]);
                  } else {
                    that.oddjzjl.push(that.alljzjl[i]);
                  }
                }
              } else {
                that.jzjl = that.alljzjl;
              }
            }
            //推荐穴位
            let xwList=[];
            if(res.data.acupunctures){
              res.data.acupunctures.forEach(item => {
              let kong = []
              let pingyin = Array.from(item.pinyin.trim().split(" "))
              let pyName = Array.from(item.name)
              pyName.filter((item, j) => {
                kong.push(
                    {
                      pingyin: pingyin[j],
                      name: item
                    }
                  )
              })
              xwList.push({
                kong: kong,
                id: item.acupointId
              })
            })
            this.xwList = xwList;
            }
           
            //评价信息
            // that.evaluateInfo = res[0].data.evaluate || {};

            if (that.evaluateInfo.id) {
              that.evaluateInfo.headImg = res.data[0].headImg;
              that.$nextTick(() => {
                that.levelText = that.levelList.find(
                  ele => ele.value == that.evaluateInfo.evaluateGrade
                ).lableTwo;
              });

              // console.log(that.evaluateInfo);
            }
          } else if (res.code == 20001) {
            that.dialogTableVisibleQX = true;
          } else {
            that.$message.error(res.msg);
          }
        })
    },
    //获取医案详情
    async getDetailYiAn(id) {
      let that = this;
      let params = {
        id: id
      };
      let url = "medicalCasesPc/getYaById";
      await that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            that.form.ya = res.data;
            if (that.form.ya.childbearingHistory) {
              if (that.form.ya.childbearingHistory == "5") {
                that.form.ya.childbearingHistory = "多个";
              }
            }
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    //咨询医师
    consultation() {
      this.$router.push({
        path: "/doctorList",
        query: {
          id: this.$route.query.id,
          medId: this.$route.query.medId
        }
      });
    },
    //获取医师信息
    async getYiShi(id) {
      let that = this;
      let params = {
        userId: id
      };
      let url = "physician/getPhysician";
      await that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            that.form.da.physician = {};
            for (let i = 0; i < that.form.da.physician.length; i++) {
              that.form.da.physician[i] = "";
            }
            that.form.da.physician.name = res.data.realName;
            that.form.da.physician.hospital = res.data.hospital;
            that.form.da.physicianCommunicationList = [];
            that.form.da.physicianCommunicationList.push({
              createDate: new Date()
            });
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    //咨询医师确定按钮
    askYiShi() {
      let that = this;
      let ysid = "";
      if (that.$route.query.ysId) {
        ysid = that.$route.query.ysId;
      } else {
        if (JSON.parse(sessionStorage.getItem("YS"))) {
          // 医师，取档案id
          ysid = that.form.ya.userId;
        } else {
          //普通用户
          ysid = that.form.da.physician ? that.form.da.physician.id : "";
        }
      }
      if (!ysid) {
        that.$message({
          type: "warning",
          message: "请您先去选择一个医师进行咨询"
        });
        return false;
      }
      if (!that.content) {
        that.$message({
          type: "error",
          message: "请您输入内容"
        });
        return false;
      }

      let params = {
        physicianDiagnoseId:
        that.form.da.physicianCommunicationList[0].physicianDiagnoseId,
        replyPeople: that.userInfo.id,
        lookPeople: ysid,
        // archivesId: that.$route.query.id,
        archivesId: that.id, //从患者消息来路由中无id，存在了localstorage中
        content: that.content,
        ys: JSON.parse(sessionStorage.getItem("YS"))
      };
      let url = "physician/physicianConsult";
      that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            // that.noDisplay = true;
            that.content = "";
            that.getDetailDangAn(that.id);
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    //修改方剂弹框，
    //有医师修正方剂显示医师修正方剂
    //没有医师修正方剂显示当代方剂
    editFangJi() {
      let that = this;
      that.alldrug()
      that.dialogTableVisible = true;
      // this.timeout = setTimeout(() => {
      //   that.getMedicine();
      // }, 5000);
      // clearTimeout(this.timeout);
      // setTimeout(that.getMedicine(), 5000);
      // that.getMedicine();
      if (that.ysxzfj.length > 0) {
        console.log('JSON.parse(JSON.stringify(that.ysxzfj))', JSON.parse(JSON.stringify(that.ysxzfj)))
        that.xgysxzfj = JSON.parse(JSON.stringify(that.ysxzfj));
      } else {
        console.log('JSON.parse(JSON.stringify(that.ddfj))', JSON.parse(JSON.stringify(that.ddfj)))
        that.xgysxzfj = JSON.parse(JSON.stringify(that.ddfj));
      }
    },
    // 远程搜索
    remoteMethod(query) {
      if (query !== '') {
        setTimeout(() => {
          this.medicinelist = this.medicinelist_all.filter(item => {
            return item.value.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.medicinelist = this.medicinelist_all.slice(0, this.rangeNumber);
      }
    },
    // 下拉框获取lable值
    handleChange(id) {
      let val = this.medicinelist.find((item) => {
        return item.id === id
      })
      this.xgysxzfj.map(items => {
        if(items.medicineName === id) {
          items.medicineName = val.value
          items.medicine = val.id
        }
      })
    },
    //确定修改方剂
    submitEdit() {
      let that = this;
      let flag = true;
      for (let i = 0; i < that.xgysxzfj.length; i++) {
        if (that.xgysxzfj[i].medicine == "") {
          flag = false;
          break;
        }
        if (that.xgysxzfj[i].dosage == "") {
          flag = false;
          break;
        }
        if (that.xgysxzfj[i].dosage != "") {
          // if (!that.numPanDuan(that.xgysxzfj[i].dosage)) {
          //   flag = false;
          // }
        }
        if (that.xgysxzfj[i].unit == "") {
          flag = false;
          break;
        }
      }
      if (flag == false) {
        that.$message.error("请将草药信息填写完整,且剂量必须为数字！");
        return false;
      }
      let params = {
        archivesId: that.$route.query.id,
        physicianChangePrescriptions: that.xgysxzfj
      };
      let url = "physician/physicianChangePrescription";
      that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            that.dialogTableVisible = false;
            that.getDetailDangAn(that.$route.query.id);
            location.reload();
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    //取消修改方剂
    cancle() {
      let that = this;
      that.dialogTableVisible = false;
    },
    // 添加一行
    addRow() {
      let that = this;
      that.xgysxzfj.push({
        medicine: "",
        dosage: "",
        unit: ""
      });
    },
    //减少一行
    reduceRow(index) {
      return this.$confirm('确定删除选中的数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let that = this;
        that.xgysxzfj.splice(index, 1);
      });
    },
    //得到所有的中草药
    alldrug() {
      let that = this;
      let url = "physician/listAllZY";
      let params = {
        atName: ''
      };
      that.$http.post(url, params).then(res => {
        res = res.data;
        if(res.code == 200) {
          let liatArr = res.data
          that.medicinelist_all = res.data
          that.medicinelist = liatArr.slice(0, this.rangeNumber)
        }
      })
    },
    // 搜索数据

    querySearchAsync(queryString, callback) {
      let that = this;
      let url = "physician/listAllZY";
      let params = {
        atName: queryString
      };
      that.$http.post(url, params).then(res => {
        res = res.data;
        if(res.data.length === 0) {
        }
        if (res.code == 200) {
          that.medicinelist = res.data;
          for(let i of res.data) {
            if(i.value === queryString) {
              callback(new Error('该药品不存在，请	输入其他药品查询'))
            }
          }
          callback(that.medicinelist);
        } else {
          that.$message.error(res.msg);
        }
      })
    },
    handleSelect(item) {
      let that = this;
      for (let index = 0; index < that.medicinelist.length; index++) {
        if (item.medicineName == that.medicinelist[index].value)
          item.medicine = that.medicinelist[index].id;
      }
    },
    //向用户申请其他诊时权限
    submitQX() {
      let that = this;
      let params = {
        id: that.jzjl[0].physicianDiagnoseId
      };
      let url = "physician/physicianWantLook";
      that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            that.dialogTableVisibleQX = false;
            that.$message({
              message: "申请成功",
              type: "success"
            });
            that.form.da.id = that.zhenshiId;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    fuZhen(id, firstTime, unmber) {
      this.$router.push({
        path: "/diagnosis",
        query: { id: id, firstTime: firstTime, unmber: unmber }
      });
    },
    //加入购物车
    addCar(id, type) {
      let that = this;
      if (!that.isLoginF()) return false;
      if (that.maxDoseList != null && that.maxDoseList.length != 0) {
        let messageName = "";
        for (var i = 0; i < that.maxDoseList.length; i++) {
          if (that.maxDoseList.length == 1) {
            messageName += that.maxDoseList[i].ypglName;
          } else {
            messageName += that.maxDoseList[i].ypglName + "、";
          }
        }
        this.$alert(
          '<strong><span style="color:red">' +
          messageName +
          "</span> </strong>超出最大剂量!",
          "提示",
          {
            dangerouslyUseHTMLString: true
          }
        );
        return false;
      }
      //立即购买
      this.$router.push({
        path: "/ReceivingAddress2",
        query: { id: id, type: type }
      });
    },

    //显示评价框
    onChangeEvaluate() {
      this.evaluateFromVisible = true;

      this.$nextTick(() => {
        document
          .getElementById("evaluateDom")
          .scrollIntoView({ behavior: "smooth" });
      });
    },

    //获取评价状态列表
    async getLevelList() {
      let that = this;
      let params = {
        sysDictType: "eva_grade"
      };
      let url = "common/findSysDictList";
      await that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            that.levelList = res.data;
            that.levelValue = res.data[0].value;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },

    //评论
    saveEvaluate() {
      let that = this;
      let id = that.$route.query.id;

      if (!that.evaluateText) {
        that.$message("请输入评价内容");
        return;
      }
      let params = {
        archivesId: id,
        evaluateGrade: that.levelValue,
        content: that.evaluateText
      };

      let url = "medicalCasesPc/saveEvaluate";
      that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            that.$message.success(res.msg);
            that.getDetailDangAn(id);
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
      //this.that.getDetailDangAn(that.$route.query.id)
    },
    /* 古方详情*/
    goAncientDetails(data) {
      let id= this.$route.query.id
      this.$router.push({
        path: "/archives",
        query: { id: id, medId: this.obj.medId, gfId:data.id}
      });
    },
     /* 穴位详情*/
    goAcupointDetails(item){
      this.$router.push({
        path: "/xueWeiDetail",
        query: { id: item.id}
      });
    }

  },
  created() {
    let that = this;
    that.getLevelList();
    that.unitMeasu()
    // that.alldrug()
    if (sessionStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    }
    if (sessionStorage.getItem("YS")) {
      that.isYS = JSON.parse(sessionStorage.getItem("YS"));
    }

    if (!!that.$route.query.id) {
      // 档案详情
      that.id = that.$route.query.id;
      that.getDetailDangAn(that.$route.query.id).then(res => {
        if (!!that.$route.query.ysId) {
          //医师详情
          that.getYiShi(that.$route.query.ysId);
          // that.getFenXi(that.$route.query.ysId);
        }
      });
      //医案详情
      that.getDetailYiAn(that.$route.query.medId);
    }
    // 患者通知从消息页面过来的
    if (localStorage.getItem("archivesId")) {
      that.getDetailDangAn(localStorage.getItem("archivesId"));
      that.id = localStorage.getItem("archivesId");
      that.getDetailYiAn(localStorage.getItem("medId"));
      localStorage.clear();
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hanzi {
  width: 50px;
  height: 50px;
  border: 1px solid #F64320;
  position: relative;
  margin-right: 10px;
}

.tianzige{
   margin-top: 50%;
   border-bottom: 1px #F64320 dashed;
}
.tianzige2 {
  width: 50px;
  height: 50px;
  position: absolute;
  top: 0;
  left: 50%;
  border-left: 1px dashed #F64320;
}
.zt {
  font-size: 30px;
  color: black;
  position: relative;
  top: -43%;
  width: 50px;
  text-align: center;
}
.viewInfo {
  color: #F64320;
}
.box-content {
  width: 70%;
  height: 160px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.box{
  width: 100%;
  height: 200px;
  border: 1px solid #cccccc;
  margin-bottom: 10px;
  align-items: center;
  display: flex;
  justify-content: space-around;
  cursor: pointer;
}
.box2{
  width: 100%;
  height: 100px;
  border: 1px solid #cccccc;
  margin-bottom: 10px;
  align-items: center;
  display: flex;
  justify-content: space-around;
  cursor: pointer;
}
.box2 .box-content {
  width: 70%;
  height: 60px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.box2 .box-content .hanzi{
  width: 40px;
    height: 40px;
    border: 1px solid #F64320;
    position: relative;
    margin-right: 10px;
}
.box2 .zt{
  font-size: 20px;
  width: 40px;
}
.box2 .tianzige2{
  width: 40px;
    height: 40px;
}
.box2 .pinying{
  width: 40px;
}
.pinying {
  position: absolute;
  top: -22px;
  width: 50px;
  text-align: center;
}
.goutongTable tr td {
  min-width: 50px;
}
.head-img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}
.table {
  border-collapse: collapse;
}

.three-white {
  padding: 20px 20px 26px 20px;
}
.desc-words {
  font-weight: bold;
  letter-spacing: 1.6px;
  color: #333333;
}
.date-time {
  color: #999999;
}
.common-row {
  padding-top: 20px;
  padding-bottom: 19px;
  border-bottom: 1px solid #dddddd;
}
.common-row1 {
  margin-left: 70px;
}
.more {
  text-align: center;
  margin-top: 20px;
}
.table .el-select {
  width: 100%;
}
.contentQX {
  font-size: 16px;
  line-height: 36px;
  letter-spacing: 2px;
  color: #666666;
}
.smallRedSize {
  font-size: 12px;
  color: red;
  margin-bottom: 20px;
}
.orangeQX {
  color: #f68f20;
}
.el-input__inner {
  text-align: left !important;
}
</style>
<style>
.small-select-mini {
  width: 100px;
  margin-right: 10px;
}
.small-select-mini .el-input--mini .el-input__inner {
  height: 24px;
  line-height: 24px;
}
.social-share .icon-wechat .wechat-qrcode {
  top: 40px !important;
  left: -165px !important;
}
.test {
  font-size: 14px;
  color: #E35131;
  margin-bottom: 12px;
}
.test span {
  width: 18px;
  height: 18px;
  color: #fff;
  border-radius: 50%;
  font-size: 14px;
  border: 1px solid #E35131;
  background-color: #E35131;
  display: inline-block;
  text-align: center;
  line-height: 18px;
}
.test1 {
  font-size: 14px;
  color: #5AB1E9;
  margin-bottom: 12px;
}
.test1 span {
  width: 18px;
  height: 18px;
  color: #fff;
  border-radius: 50%;
  font-size: 14px;
  border: 1px solid #5AB1E9;
  background-color: #5AB1E9;
  display: inline-block;
  text-align: center;
  line-height: 18px;
}
.test2 {
  font-size: 14px;
  color: #5ECFC5;
  margin-bottom: 12px;
}
.test2 span {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-size: 14px;
  border: 1px solid #5ECFC5;
  display: inline-block;
  text-align: center;
  line-height: 18px;
}
.test3 {
  font-size: 14px;
  color: #EFAB46;
  margin-bottom: 12px;
}
.test3 span {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-size: 14px;
  border: 1px solid #EFAB46;
  display: inline-block;
  text-align: center;
  line-height: 18px;
}
.wuxing {
  width: 100%;
  overflow: hidden;
  margin-bottom: 2px;
  display: flex; /* 20210722 */
}
.wuxing_name {
  width: 20%;
  height: 43px;
  line-height: 43px;
  text-align: center;
  border: 1px solid #ebe7dd;
  background-color: #fffaf6;
  /*float: left;   20210722*/
}
.wuxing_num {
  width: 74.5%;
  height: 43px;
  line-height: 43px;
  text-align: left;
  padding-left: 5%;
  border: 1px solid #ebe7dd;
  background-color: #fffaf6;
  /*float: left;   20210722*/
}
.wuxi {
  margin-bottom: 22px;
}
.set-small-width {
  width: 100%;
}


.setWidth{
  width: 80%;
}
.remarks {
  margin: -20px 0 10px 0;
  margin-left: 8px;
  color: #F64320;
}
</style>



// WEBPACK FOOTER //
// src/components/JW/recResults.vue